import { render, staticRenderFns } from "./ModuleTypeSlidebar.vue?vue&type=template&id=76d2cd80"
import script from "./ModuleTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports